import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: ${props => props.width || '110mm'};
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: ${props => props.minHeight || '80px'};
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-top: none;
  border-bottom: ${props => props.readOnly ? '1px solid #e0e0e0' : 'none'};
  border-radius: ${props => props.readOnly ? '0 0 6px 6px' : '0'};
  resize: vertical;
  font-family: Poppins;
  font-size: 13px;
  color: #333;
  transition: border-color 0.2s;
  background: ${props => props.readOnly ? '#f9f9f9' : 'white'};
  cursor: ${props => props.readOnly ? 'default' : 'text'};

  &:focus {
    outline: none;
    border-color: ${props => props.readOnly ? '#e0e0e0' : '#3bd2c1'};
  }

  &::placeholder {
    color: #999;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 0 0 6px 6px;
`;

export const Header = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #666;
  text-align: center;
  padding: 4px 10px;
  background: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 6px 6px 0 0;
`;

export const CharCount = styled.span`
  font-size: 12px;
  color: #666;
`;
